import React from 'react';
import { Check, X, Minus } from 'lucide-react';
import { comparisonRows } from '../mock';

const CellValue = ({ text, best }) => {
  const isYes = text.toLowerCase().includes('yes') || text.toLowerCase().includes('included') || text.toLowerCase().includes('native') || text.toLowerCase().includes('every');
  const isNo = text === '—' || text.toLowerCase().includes('not offered');
  return (
    <div className={`flex items-start gap-2 text-[14px] ${best ? 'font-semibold text-stone-900' : 'text-stone-600'}`}>
      {isYes && <Check size={16} className="text-emerald-600 mt-0.5 flex-shrink-0" strokeWidth={2.5} />}
      {isNo && <Minus size={16} className="text-stone-400 mt-0.5 flex-shrink-0" />}
      <span>{text}</span>
    </div>
  );
};

const Comparison = () => {
  return (
    <section id="agency" className="py-20 md:py-28 bg-white border-y border-stone-200">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-[12px] font-bold uppercase tracking-widest text-[#4F46E5] mb-3">Head to head</p>
          <h2 className="text-[34px] md:text-[44px] font-extrabold text-stone-900 leading-tight">
            Ambanji vs the other options
          </h2>
          <p className="mt-4 text-[15px] text-stone-600">
            An honest comparison. Not every column is a knock on the other tools — we just do a couple of things differently.
          </p>
        </div>

        <div className="rounded-2xl border border-stone-200 overflow-hidden bg-white">
          <div className="grid grid-cols-[1.4fr_1fr_1fr_0.9fr] bg-stone-50 border-b border-stone-200">
            <div className="p-4 text-[12px] font-bold uppercase tracking-widest text-stone-500">Feature</div>
            <div className="p-4 text-[13px] font-bold text-stone-900 border-l border-stone-200 bg-orange-50">
              <span className="inline-flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-[#F97316]"></span> Ambanji
              </span>
            </div>
            <div className="p-4 text-[13px] font-semibold text-stone-700 border-l border-stone-200">Merchynt</div>
            <div className="p-4 text-[13px] font-semibold text-stone-700 border-l border-stone-200">DIY</div>
          </div>

          {comparisonRows.map((row, idx) => (
            <div key={idx} className={`grid grid-cols-[1.4fr_1fr_1fr_0.9fr] ${idx % 2 === 1 ? 'bg-stone-50/40' : ''}`}>
              <div className="p-4 text-[14px] font-semibold text-stone-800 border-t border-stone-200">{row.feature}</div>
              <div className="p-4 border-t border-l border-stone-200 bg-orange-50/40">
                <CellValue text={row.ambanji} best />
              </div>
              <div className="p-4 border-t border-l border-stone-200">
                <CellValue text={row.merchynt} />
              </div>
              <div className="p-4 border-t border-l border-stone-200">
                <CellValue text={row.diy} />
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 text-center text-[12px] text-stone-500">
          Competitor pricing based on publicly listed rates as of the current billing cycle. Fair-use nominative comparison.
        </p>
      </div>
    </section>
  );
};

export default Comparison;
